import { theme } from 'lib';
import styled from 'styled-components';

const StyledTr = styled.tr`
  width: 100%;
  border-spacing: 0;
  cursor: pointer;
  height: 53px;

  &:hover {
    background-color: ${theme.GREY_10};
  }
`;

export default StyledTr;
